<!--SMS Message-->
<div class="row ml-4 mr-4 mt-4 mb-1">
  <div class="col-md-12 message-send-page">
    <div class="navigation">
      <img class="image-back" src="../../../../../assets/images/back.png" (click)="navigateToMessagesPage()" alt="Back">
      <span class="label-back">Back to Messages</span>
    </div>
    <div class="title-box">
      <span class="title-section">Send {{this._selectedMessageType === this._messageTypeEnumEmail ?  'Email' : 'SMS Message' }}</span>
    </div>

    <div class="message-send-section">
      <span class="title-sub-section">Send {{this._selectedMessageType === this._messageTypeEnumEmail ?  'Email' : 'SMS Message' }}: '{{this._messageName}}'</span>
      <hr class="mt-1 mb-0">
      <!-- First Row -->
      <!-- Form -->
      <form [formGroup]="_formGroupConfigurator" (ngSubmit)="onConfiguratorFormGroupSubmit()">
        <div class="form-body pt-2">
          <div class="form-row">
            <div class="col-md-2">
              <label for="listFolders" class="input-label">Folder</label>
              <select class="form-control select-input"
                      name="listFolders"
                      id="folders" formControlName="listFolders">
                <option value=0 hidden>Select Folder</option>
                <option *ngFor="let listFolder of _listFolderSelectListOptions; let i = index"
                        [value]="listFolder.value">
                  {{listFolder.label}}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label for="list" class="input-label">List</label>
              <select class="form-control select-input"
                      name="list" formControlName="lists"
                      id="lists">
                <option value=0  hidden>Select List</option>
                <option *ngFor="let list of _listsSelectListOptions; let i = index"
                        [value]="list.value">
                  {{list.label}}
                </option>
              </select>
            </div>
            <div *ngIf="this._selectedMessageType === this._messageTypeEnumEmail; then emailBlock else smsBlock"></div>
            <ng-template #emailBlock>
              <div class="col-md-4">
                <label class="input-label" for="from">From</label>
                <input type="text" id="from" class="form-control input-style" formControlName="from" readonly />
              </div>
              <div class="col-md-2">
                <label class="input-label" for="subject" *ngIf="_isRegularSendType">Subject</label>
                <input type="text" id="subject" class="form-control input-style" formControlName="subject" readonly *ngIf="_isRegularSendType">
              </div>
            </ng-template>
            <ng-template #smsBlock>
              <div class="col-md-6" *ngIf="this._selectedMessageType === this._messageTypeEnumSms">
                <label for="message" class="input-label">Message</label>
                <textarea mdbTooltip="Text is read only" formControlName="message" type="text" id="message"
                          class="form-control textarea-style" readonly></textarea>
              </div>
            </ng-template>
            <div class="col-md-2 button-box">
              <div class="d-flex justify-content-end">
                <button *ngIf="this._sending"
                        type="button"
                        class="btn-okay rounded mb-2"
                        disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Sending...
                </button>
                </div>
              <div class="d-flex justify-content-end">
                <button
                        *ngIf="(this._selectedMessageType === _messageTypeEnumEmail && this._userPermissions.Messaging.MessagesEmail.Send ||
                        this._selectedMessageType === _messageTypeEnumSms && this._userPermissions.Messaging.MessagesSMS.Send)
                        && !this._sending"
                        [disabled]="this.isSendButtonDisabled()"
                        type="submit"
                        class="btn-okay mb-2">
                  <span>
                    <mdb-icon fas icon="envelope" size="lg"></mdb-icon>
                    Send
                  </span>
                </button>
                </div>
              <div class="d-flex justify-content-end">
                <button type="button"
                        class="btn-cancel mb-2"
                        [routerLink]="['/messages']">
                  <span class="text-truncate">Cancel</span>
                </button>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="this._selectedMessageType === _messageTypeEnumEmail">
            <div class="col-md-auto">
              <div class="custom-control custom-radio">
                <input id="send-email-type-regular" type="radio" class="custom-control-input" value="1" name="sendEmailType" formControlName="sendEmailType">
                <label class="custom-control-label" for="send-email-type-regular">Regular</label>
              </div>         
            </div>

            <div class="col-md-auto" *ngIf="this._isMdUser || this._isLoggedInClientAllowed">
              <div class="custom-control custom-radio">
                <input id="send-email-type-a-b" type="radio" class="custom-control-input" value="2" name="sendEmailType" formControlName="sendEmailType">
                <label class="custom-control-label" for="send-email-type-a-b">A/B Test</label>
              </div>              
            </div>
          </div>

          <div class="a-b-testing margin-top-20" *ngIf="!_isRegularSendType">

            <div class="row subjects">
              <div class="col-md-6">
                <label class="label-style-bold" for="subjectA">Subject A</label>
                <input type="text" id="subjectA" class="form-control input-style" formControlName="subjectA" readonly>
              </div>

              <div class="col-md-6">
                <label class="label-style-bold" for="subjectB">Subject B</label>
                <input type="text" id="subjectB" class="form-control input-style" formControlName="subjectB">
              </div>
            </div>

            <div class="row margin-top-20">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-auto">
                    <label class="label-style-bold">Test Metric</label>
                  </div>
  
                  <div class="col-md-auto">
                    <label class="label-style-regular">Open Rate</label>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <label class="label-style-bold">Contact List Test Size</label>
              </div>
            </div>

            <div class="row margin-top-20">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-auto">
                    <label class="label-style-bold">Test Length</label>
                  </div>
  
                  <div class="col-md-auto">
                    <input type="number" id="abTestLength" class="form-control input-style" formControlName="abTestLength" min="1" (ngModelChange)="onabTestLengthChange($event)" onkeypress="return event.charCode > 48"/>
                  </div>

                  <div class="col-md-auto">
                    <select class="form-control select-input"
                            name="abTestLengthType"
                            id="abTestLengthType" 
                            formControlName="abTestLengthType">
                      <option value=1>{{ _abTestLengthTypeHours }}</option>
                      <option value=2>{{ _abTestLengthTypeDays }}</option>
                    </select>
                  </div>

                  <div class="col-md-auto">
                    <label class="label-style-regular">We recommend you test for at least 4 hours</label>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-10">
                    <mdb-range-input class="range-field" min="10" max="100" step="10" value="10" formControlName="abTestSize" (rangeValueChange)="onTestSizeValueChange($event)"></mdb-range-input>
                  </div>

                  <div class="col-md-2">
                    <label class="label-style-regular">{{_selectedRangePercent}}%</label> 
                  </div>               
                </div>
                <div class="row">
                  <div class="col-md-auto">
                    <label class="label-style-regular">A Recipients {{_subjectACount}} ({{_subjectAPercent}}%), B Recipients {{_subjectBCount}} ({{_subjectBPercent}}%), Winner Recipients {{_winningCount}} ({{_winningPercent}}%)</label> 
                  </div>
                </div>
              </div>
            </div>

            <div class="row margin-top-20">
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-10">
                    <div class="alert alert-warning justify-content-center" role="alert" *ngIf="_showWrongSizeOrContactsCountWarning">
                      No contacts will be sent the A/B test message. Either increase the Test Size or add more recipients.
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </form>
      <!-- Form -->
      <!-- /First Row -->
    </div>

    <div class="messages-table-section">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <span class="title-table-section">Contacts</span>
        </div>
        <div>
          <button [disabled]="_selectedListId === 0"
                  mdbBtn outline="true" rounded="true" size="sm" type="button"
                  class="table-button px-2 mr-2" mdbWavesEffect (click)="openExcludeModal()">
                  <mdb-icon fas size="lg" class="table-icon" icon="user-minus"></mdb-icon>
          </button>
        </div>
        <div>
          <button *ngIf="this.filterContactRules.length === 0" [disabled]="_selectedListId === 0"
                  mdbBtn outline="true" rounded="true" size="sm" type="button"
                  class="table-button px-2 mr-2" mdbWavesEffect (click)="filterContactsModal.show()">
            <mdb-icon fas size="lg" class="table-icon" icon="search"></mdb-icon>
          </button>
        </div>
        <div>
          <button *ngIf="this.filterContactRules.length > 0" [disabled]="_selectedListId === 0"
                  mdbBtn outline="true" rounded="true" size="sm" type="button"
                  mdbTooltip="An active filter is set, click here to clear or edit it."
                  placement="top" class="table-button active px-2 mr-2" mdbWavesEffect
                  (click)="filterContactsModal.show()">
            <mdb-icon class="table-icon" fas size="lg" icon="search"></mdb-icon>
          </button>
        </div>
        <div>
          <button [disabled]="!_tableHasRows" mdbBtn outline="true" rounded="true" size="sm"
                  type="button" class="px-2 table-button mr-0" mdbWavesEffect (click)="columnOptions.toggle()">
            <mdb-icon fas size="lg" class="table-icon" icon="columns"></mdb-icon>
          </button>
        </div>
      </div>
      <hr class="hr-contact">

        <mdb-card-body cascade="true" class="text-center pr-0 pt-0 pl-0">
          <section>
            <div class="container-fluid pl-2 pr-2">
              <div class="row text-left" mdbCollapse #columnOptions="bs-collapse">
                <div class="col-3 font-size-12" *ngFor="let col of _allColumns; index as i">
                  <mat-checkbox id="checkbox-{{i}}"
                                [checked]="col.visible"
                                [value]="col.prop"
                                (change)="changeVisibleColumn($event, col)">
                    {{col.name}}
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </section>
        </mdb-card-body>

        <div *ngIf="_tableHasRows" class="mat-table-container">
          <table mat-table [dataSource]="_data" matSort (matSortChange)="onSortColumn()">
            <ng-container [matColumnDef]="column.Name" *ngFor="let column of _displayedColumns; let i = index;">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="header">{{column.DisplayName}}</th>
              <td mat-cell *matCellDef="let element">
                {{  element[column.Name] }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="_columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: _columnsToDisplay;"></tr>
          </table>
          <mat-paginator [hidden]="!_tableHasRows"
                         [length]="_pageCount"
                         [pageSize]="_pageLimit"
                         [pageSizeOptions]="_pageSizeOptions"
                         [pageIndex]="_pageIndex"
                         (page)="onChangePage($event)">
          </mat-paginator>
        </div>
        <div *ngIf="!_tableHasRows">
          <span class="label-no-data">No data to display.</span>
        </div>
      </div>
    </div>
</div>

    <!-- Confirm Send Modal -->
    <div mdbModal #confirmSendModal="mdb-modal" class="modal fade" id="confirmSendModal" tabindex="-1" role="dialog"
         aria-labelledby="myModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-notify modal-warning" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <p class="heading lead">Confirm Send</p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="confirmSendModal.hide()">
              <span aria-hidden="true" class="white-text">×</span>
            </button>
          </div> <!--modal-header-->
          <div class="modal-body">
            <div class="text-center mb-3">
              <mdb-icon fas icon="question-circle" size="4x" class="animated rotateIn"></mdb-icon>
            </div>  <!--text-center-->
            <form [formGroup]="_formGroupConfirmSend" (ngSubmit)="this.onConfirmSendFormGroupSubmit()">
              <div>
                <div *ngIf="_countUniqueContacts > 0 && filterContactRules === ''" class="mb-3">
                  {{_selectedMessageType === _messageTypeEnumEmail ? "Email" : "SMS"}} message will be sent to {{_countUniqueContacts}} contact{{ _countUniqueContacts > 1 ? 's' : ''  }}
                  excluding duplicates. <br><br> If you press OK, You won't be able to revoke this action.
                </div>
                <div *ngIf="_countUniqueContacts > 0 && filterContactRules.length > 0" class="mb-3">
                  {{_selectedMessageType === _messageTypeEnumEmail ? "Email" : "SMS"}} message will be sent to {{_countUniqueContacts}} contact{{ _countUniqueContacts > 1 ? 's' : ''  }}
                  following this critieria excluding duplicates: <br><br> {{filterContactRules}} <br><br> If you press OK, You won't be able to revoke this action.
                </div>
                <div *ngIf="_countUniqueContacts == 0" class="mb-3">
                  Cannot send any messages. All {{_selectedMessageType === _messageTypeEnumEmail ? "Email" : "SMS"}} consent fields are set to NO.
                </div>
                <div class="modal-footer justify-content-center">
                  <button *ngIf="_countUniqueContacts > 0" type="submit" [disabled]="!this._tableHasRows" mdbBtn color="primary" class="waves-light rounded text-white" mdbWavesEffect>OK</button>
                  <button type="button" mdbBtn color="secondary" class="rounded" outline="true" data-dismiss="modal" (click)="confirmSendModal.hide()" mdbWavesEffect>Cancel</button>
                </div><!--modal-footer-->
              </div><!--md-form-->
            </form><!--form-->
          </div> <!--modal-body-->
        </div>  <!--modal-content-->
      </div> <!--modal-dialog-->
    </div> <!--mdbModal-->
    <!-- Confirm Send Modal -->


    <!-- Filter Contacts Modal  -->
    <div mdbModal #filterContactsModal class="modal fade modal-overflow" tabindex="-1" role="dialog" aria-labelledby="filterContactsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content rounded-lg">
          <div class="modal-header">
            <button type="button" class="close pull-right" aria-label="Close" (click)="filterContactsModal.hide()">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title w-100" id="filterContactstModalLabel">Filter Contacts</h4>
          </div>

          <div class="modal-body">
            <app-query-builder
                               #queryBuilder
                               [(_parentListID)]="this._selectedListId"
                               [(_parentQuery)]="this.filterContactRules"
                               [_parentSource]="'contacts'"
                               (queryBuilderSave)="contactsFilterSave($event)"
                               [(_parentPageTitle)]="this._pageTitle">
            </app-query-builder>
          </div>
        </div>
      </div>
    </div>
    <!--/Filter Contacts Modal-->

    <!--/SMS Message-->

<div class="d-flex justify-content-center spinner" *ngIf="this._showSpinner">
  <mdb-spinner spinnerType="big"></mdb-spinner>
</div>
